"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.style.list': '写作风格',
    'route.style.create': '添加写作风格',
    'route.style.edit': '编辑写作风格',
    'route.style.preview': '预览风格',
};
